import React from "react";

const EEWrapper = ({ children }: { children: React.ReactElement }) => {
  if (true) {
    return children;
  } else {
    return <></>;
  }
};
export default EEWrapper;
